import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import "@/i18n";
import ScrollToTop from "@/components/ScrollToTop";
import CookieBanner from "@/components/CookieBanner";
import LangLayout from "@/components/LangLayout";
import HomePage from "@/pages/HomePage";
import { PrivacyPage, CookiesPage, TermsPage } from "@/pages/LegalPages";
import ThankYouPage from "@/pages/ThankYouPage";
import NotFoundPage from "@/pages/NotFoundPage";

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Navigate to="/pe" replace />} />
        <Route path="/thank_you" element={<ThankYouPage />} />
        <Route path="/:lang" element={<LangLayout />}>
          <Route index element={<HomePage />} />
          <Route path="privacy" element={<PrivacyPage />} />
          <Route path="cookies" element={<CookiesPage />} />
          <Route path="terms" element={<TermsPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
        <Route path="*" element={<Navigate to="/pe" replace />} />
      </Routes>
      <CookieBanner />
    </BrowserRouter>
  );
}

export default App;
